import ButtonCellBottomAddon from "./ButtonCellBottomAddon";
import createFabric from "../../../../../fabrics/createFabric";

export default createFabric("BottomAddon", ButtonCellBottomAddon);
